import { useQuery } from '@tanstack/react-query';
import { useMemo, useState } from 'react';
import { ProjectAPI, ProjectCreationStatusState } from 'api/project';
import { fetchProjectDetail } from 'collections/project';
import { useProjectsFromInitData } from 'queries/account';
import { useProjectDetailQuery } from 'queries/project';
export const useProjectDetail = (projectId, options = {})=>{
    var _options_enabled;
    const id = projectId === null || projectId === void 0 ? void 0 : projectId[1];
    const hasValidProjectId = id != null && Number.isFinite(id) && id > 0;
    return useProjectDetailQuery(projectId, {
        retry: 1,
        retryOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnMount: true,
        refetchOnReconnect: false,
        ...options,
        enabled: hasValidProjectId && ((_options_enabled = options.enabled) !== null && _options_enabled !== void 0 ? _options_enabled : true)
    });
};
export const useProject = ([, id])=>{
    const { data } = useProjectsFromInitData();
    return useMemo(()=>data === null || data === void 0 ? void 0 : data.byId[id], [
        data === null || data === void 0 ? void 0 : data.byId,
        id
    ]);
};
export const projectCreateStatusQueryKey = (projectId)=>{
    return [
        'project-creation-status',
        projectId
    ];
};
export const useProjectCreationStatus = (projectId)=>{
    const [prevState, setPrevState] = useState([]);
    const query = useQuery(projectCreateStatusQueryKey(projectId), ()=>{
        return ProjectAPI.getProjectCreationStatus(projectId);
    }, {
        refetchInterval: (data)=>{
            if (data) {
                var _ref;
                const inprogress = (_ref = data === null || data === void 0 ? void 0 : data.filter((e)=>(e === null || e === void 0 ? void 0 : e.status) === ProjectCreationStatusState.InProgress)) !== null && _ref !== void 0 ? _ref : [];
                if (inprogress.length > 0) {
                    return 1000;
                }
                return false;
            }
            return false;
        },
        onSuccess: async (data)=>{
            var _data_filter, _prevState_filter;
            if (data) {
                setPrevState(data);
            }
            const completedCount = data === null || data === void 0 ? void 0 : (_data_filter = data.filter((e)=>(e === null || e === void 0 ? void 0 : e.status) === ProjectCreationStatusState.Completed)) === null || _data_filter === void 0 ? void 0 : _data_filter.length;
            const prevCompletedCount = prevState === null || prevState === void 0 ? void 0 : (_prevState_filter = prevState.filter((e)=>(e === null || e === void 0 ? void 0 : e.status) === ProjectCreationStatusState.Completed)) === null || _prevState_filter === void 0 ? void 0 : _prevState_filter.length;
            if (prevCompletedCount < completedCount && completedCount !== 0) {
                // Detail is collection-backed — refetch+push so consumers update.
                await fetchProjectDetail(projectId);
            }
        }
    });
    return query;
};
export const useGetProjectMembers = (projectId)=>{
    return useQuery([
        'project-members',
        projectId
    ], ()=>ProjectAPI.getProjectMembers(projectId));
};
